type Env = {
  NODE_ENV: string;
  VUE_APP_SSO_COOKIE_NAME: string;
  VUE_APP_COOKIES_DOMAIN: string;
  VUE_APP_API_BASE_PATH_ORDER: string;
  VUE_APP_TLPF_SRC: string;
  VUE_APP_TLPF_KEY: string;
  VUE_APP_BENEFIT_BENEFITSTATION_URL: string;
  VUE_APP_BENEFIT_SELECT_PAYMENT: string;
  VUE_APP_SUBS01_ERR_NO_SELECT_TARGET_PERSON: string;
  VUE_APP_SUBS01_ERR_NO_INPUT: string;
  VUE_APP_SUBS01_ERR_DUPLICATED: string;
  VUE_APP_SUBS01_ERR_NO_SELECT_USE_DATE: string;
  VUE_APP_SUBS01_ERR_NEGATIVE: string;
  VUE_APP_SUBS01_ERR_EMPTY_TARGET_PERSON: string;
  VUE_APP_CAFE01_ERR_EXCEED_POINT: string;
  VUE_APP_CAFE01_ERR_EXCEED_CASH: string;
  VUE_APP_CAFE01_ERR_BLANK: string;
  VUE_APP_CAFE01_ERR_NEGATIVE: string;
  VUE_APP_CAFE01_ERR_NUM: string;
  VUE_APP_CAFE01_ERR_OVER: string;
  VUE_APP_BENP01_ERR_BLANK: string;
  VUE_APP_BENP01_ERR_EXCEED: string;
  VUE_APP_BENP01_ERR_NEGATIVE: string;
  VUE_APP_BENP01_ERR_NUM: string;
  VUE_APP_BENP01_ERR_OVER: string;
  VUE_APP_SUBS01_ERR_AGE_OUT_OF_RANGE: string;
  VUE_APP_SUBS01_ERR_OVER_PRICE: string;
  VUE_APP_SUBS01_ERR_OVER_QUANTITY: string;
  VUE_APP_SUBS01_ERR_NO_COUPON: string;
  VUE_APP_FT_BENEFIT_APPLYING_ERROR: string;
  VUE_APP_UNMATCH_ORDERSITE_ERROR: string;
  VUE_APP_SUBS01_ERR_RELATIONSHIP_ID: string;
  VUE_APP_RAKUTEN_NO_PAYMENT_ERROR: string;
};

export default class EnvRepository {
  static getEnv(): Env {
    return (
      (process.env as Env) ?? {
        NODE_ENV: '',
        VUE_APP_SSO_COOKIE_NAME: '',
        VUE_APP_COOKIES_DOMAIN: '',
        VUE_APP_API_BASE_PATH_ORDER: '',
        VUE_APP_TLPF_SRC: '',
        VUE_APP_TLPF_KEY: '',
        VUE_APP_BENEFIT_BENEFITSTATION_URL: '',
        VUE_APP_BENEFIT_SELECT_PAYMENT: '',
        VUE_APP_SUBS01_ERR_NO_SELECT_TARGET_PERSON: '',
        VUE_APP_SUBS01_ERR_NO_INPUT: '',
        VUE_APP_SUBS01_ERR_DUPLICATED: '',
        VUE_APP_SUBS01_ERR_NO_SELECT_USE_DATE: '',
        VUE_APP_SUBS01_ERR_NEGATIVE: '',
        VUE_APP_SUBS01_ERR_EMPTY_TARGET_PERSON: '',
        VUE_APP_CAFE01_ERR_EXCEED_POINT: '',
        VUE_APP_CAFE01_ERR_EXCEED_CASH: '',
        VUE_APP_CAFE01_ERR_BLANK: '',
        VUE_APP_CAFE01_ERR_NEGATIVE: '',
        VUE_APP_CAFE01_ERR_NUM: '',
        VUE_APP_CAFE01_ERR_OVER: '',
        VUE_APP_BENP01_ERR_BLANK: '',
        VUE_APP_BENP01_ERR_EXCEED: '',
        VUE_APP_BENP01_ERR_NEGATIVE: '',
        VUE_APP_BENP01_ERR_NUM: '',
        VUE_APP_BENP01_ERR_OVER: '',
        VUE_APP_SUBS01_ERR_AGE_OUT_OF_RANGE: '',
        VUE_APP_SUBS01_ERR_OVER_PRICE: '',
        VUE_APP_SUBS01_ERR_OVER_QUANTITY: '',
        VUE_APP_SUBS01_ERR_NO_COUPON: '',
        VUE_APP_FT_BENEFIT_APPLYING_ERROR: '',
        VUE_APP_UNMATCH_ORDERSITE_ERROR: '',
        VUE_APP_SUBS01_ERR_RELATIONSHIP_ID: '',
        VUE_APP_RAKUTEN_NO_PAYMENT_ERROR: '',
      }
    );
  }
}
